export default function Caracteristicas() {
  const features = [
    {
      badge: 'PROCESAMIENTO EN TIEMPO REAL',
      title: 'Conversaciones Naturales e Inteligentes',
      description: 'Nuestro agente de IA comprende el contexto y mantiene conversaciones fluidas como un humano, adaptándose al tono y necesidades de cada cliente.',
      benefits: [
        'Reconocimiento de voz avanzado con 99% de precisión',
        'Comprensión contextual de múltiples idiomas (Opcional)',
        'Respuestas personalizadas basadas en historial',
        'Aprendizaje continuo de cada interacción'
      ],
      image: 'https://public.readdy.ai/ai/img_res/76e2b685971c9e7734fc7ab11972d34d.jpg',
      color: 'cyan',
      imageLeft: true
    },
    {
      badge: 'ANÁLISIS INTELIGENTE',
      title: 'Análisis de Sentimiento y Emociones',
      description: 'Detecta automáticamente el estado emocional del cliente y ajusta las respuestas para proporcionar una experiencia empática y personalizada.',
      benefits: [
        'Detección de frustración y escalamiento automático',
        'Adaptación del tono según el contexto emocional',
        'Métricas de satisfacción en tiempo real',
        'Alertas proactivas para casos críticos'
      ],
      image: 'https://readdy.ai/api/search-image?query=3D%20audio%20waveform%20visualization%20with%20frequency%20spectrum%20in%20purple%20and%20pink%20neon%20colors%20floating%20in%20dark%20space%20showing%20voice%20analysis%20and%20sound%20processing%20technology&width=600&height=500&seq=feat2&orientation=landscape',
      color: 'purple',
      imageLeft: false
    }
  ];

  return (
    <section id="caracteristicas" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-[#1a1f3a] to-[#0a0e27]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {features.map((feature, index) => (
          <div 
            key={index} 
            className={`flex flex-col ${feature.imageLeft ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 sm:gap-12 items-center mb-20 sm:mb-24 md:mb-32 last:mb-0`}
          >
            <div className="w-full lg:w-1/2">
              <div className="relative group">
                <div className={`absolute -inset-4 bg-gradient-to-r ${
                  feature.color === 'cyan' ? 'from-cyan-500/20 to-blue-500/20' :
                  feature.color === 'purple' ? 'from-purple-500/20 to-pink-500/20' :
                  'from-green-500/20 to-emerald-500/20'
                } rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-300`}></div>
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <div className="w-full h-[300px] sm:h-[400px] md:h-[500px]">
                    <img 
                      src={feature.image} 
                      alt={feature.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/2">
              <div className={`inline-block px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border-2 ${
                feature.color === 'cyan' ? 'border-cyan-400 text-cyan-400' :
                feature.color === 'purple' ? 'border-purple-400 text-purple-400' :
                'border-green-400 text-green-400'
              } text-[10px] sm:text-xs font-bold tracking-wider mb-4 sm:mb-6`}>
                {feature.badge}
              </div>

              <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-4 sm:mb-6 leading-tight">
                {feature.title}
              </h3>

              <p className="text-gray-400 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
                {feature.description}
              </p>

              <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                {feature.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-2 sm:gap-3">
                    <div className={`w-5 h-5 sm:w-6 sm:h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
                      feature.color === 'cyan' ? 'bg-cyan-500/20' :
                      feature.color === 'purple' ? 'bg-purple-500/20' :
                      'bg-green-500/20'
                    }`}>
                      <i className={`ri-check-line text-xs sm:text-sm ${
                        feature.color === 'cyan' ? 'text-cyan-400' :
                        feature.color === 'purple' ? 'text-purple-400' :
                        'text-green-400'
                      }`}></i>
                    </div>
                    <span className="text-sm sm:text-base text-gray-300">{benefit}</span>
                  </li>
                ))}
              </ul>

              <button className={`group px-6 sm:px-8 py-2.5 sm:py-3 border-2 ${
                feature.color === 'cyan' ? 'border-cyan-400 text-cyan-400 hover:bg-cyan-400/10' :
                feature.color === 'purple' ? 'border-purple-400 text-purple-400 hover:bg-purple-400/10' :
                'border-green-400 text-green-400 hover:bg-green-400/10'
              } rounded-lg text-sm sm:text-base font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer`}>
                Conocer Más
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
